import { RESERVATION_CHANGE_TAB } from '../actions';

export const changeReservationsActiveTab = (activeTab) => {
  return {
    type: RESERVATION_CHANGE_TAB,
    payload: activeTab,
  };
};
